import type { GetServerSidePropsContext } from 'next'

import { PRODUCT_KEYS } from '@/legacy/components/Products/constants'
import { initBuilder } from '@/legacy/config/builder'
import Blog, { getServerSideProps as gSSP } from '@/pages/blog'

initBuilder()

export const getServerSideProps = (context: GetServerSidePropsContext) =>
  gSSP(context, PRODUCT_KEYS.carteira)

export default Blog
